import { CreditCardServiceModule } from 'services/payment/stripe/creditCard.service';
import 'components/creditCards/cardInfo/cardInfo.scss';
import { STRIPE_ELEMENTS_APPLE_PAY, STRIPE_ELEMENTS_GOOGLE_PAY } from 'app/constants';
import template from './paymentMethodSelector.html';
import './paymentMethodSelector.scss';

export const PaymentMethodModule =
    angular.module('app.components.checkout.components.paymentMethodSelector', [
        CreditCardServiceModule,
        'ngMaterial'
    ]).component('paymentMethodSelector', {
        template,
        bindings: {
            payment: '<',
            purchaseComplete: '<',
            onPaymentSelected: '<',
            onToggleEditMode: '<'
        },
        controller: class PaymentMethodCtrl {
            constructor($scope, $window, creditCardService) {
                'ngInject';

                angular.extend(this, {
                    $scope,
                    $window,
                    creditCardService,
                    paymentOptions: [],
                    supportsMultiplePayments: false,
                    STRIPE_ELEMENTS_APPLE_PAY,
                    STRIPE_ELEMENTS_GOOGLE_PAY
                });
            }

            $onInit() {
                this.creditCardService.canUsePaymentRequestAPI()
                    .then((isPaymentRequestAPISupported) => {
                        if (isPaymentRequestAPISupported) {
                            this.updateStateWithMobilePaymentOption();
                        } else if (!this.isSavedPaymentValid()) {
                            this.onToggleEditMode();
                        }
                        this.$scope.$apply();
                    });
            }

            updateStateWithMobilePaymentOption() {
                this.supportsMultiplePayments = true;
                this.paymentOption = this.getPaymentOptionDisplayName();
                this.paymentOptions.push({ name: this.getPaymentOptionDisplayName() });
                this.onPaymentOptionSelected(this.paymentOption);
            }

            onPaymentOptionSelected(selectedPayment) {
                if (!this.isSavedPaymentValid() && this.paymentOption === 'card') {
                    this.onToggleEditMode();
                }
                this.onPaymentSelected(selectedPayment);
            }

            isSavedPaymentValid() {
                return this.payment !== undefined &&
                    this.payment !== null &&
                    this.payment.brand !== undefined &&
                    this.payment.brand !== null;
            }

            getPaymentOptionDisplayName() {
                if (this.isCurrentBrowserChrome()) {
                    return STRIPE_ELEMENTS_GOOGLE_PAY;
                }
                return STRIPE_ELEMENTS_APPLE_PAY;
            }

            isCurrentBrowserChrome() {
                return this.$window.navigator.userAgent.includes('Chrome');
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/checkout/components/paymentMethodSelector/paymentMethodSelector.js